module.exports = __webpack_public_path__ + "img/h5.42bc2947.jpg";